import { useQuery } from '@tanstack/react-query';
import { serviceCatalogServices } from '../services/service-catalog.service';

const parseApiError = (error) => {
  return {
    message:
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      'Something went wrong',

    status: error?.response?.status || 500,

    errors: error?.response?.data?.errors || [],
  };
};

export const useServiceCatalog = (filters) => {
  return useQuery({
    queryKey: ['service-catalog', filters],

    queryFn: async () => {
      try {
        return await serviceCatalogServices.getServiceCatalog(filters);
      } catch (error) {
        throw parseApiError(error);
      }
    },

    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes

    placeholderData: (previousData) => previousData,

    retry: 1,
  });
};
